import React, { useEffect, useState } from "react";
import statsApi from "../../../../api/stats-api";
import { getRequestError } from "../../../../utils/functions";
import moment from "moment";
import useStyles from "../MainDashboard/MainDashboard.styles";
import DateSelector from "../../../../components/Inputs/DateSelector";
import Chart from "../../../../components/Chart";
import generateChart from "../utils/graphs";
import { CSVLink } from "react-csv";
import DownloadIcon from "@material-ui/icons/GetApp";

const ChurnRate = ({ jwt }) => {
  const [startDate, setStartDate] = useState(
    moment()
      .subtract(1, "months")
      .format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [isLoadingChurnRate, setIsLoadingChurnRate] = useState(false);
  const [churnRate, setChurnRate] = useState(null);

  const { filter, filterContainer } = useStyles({
    active: false
  });

  useEffect(() => {
    setIsLoadingChurnRate(true);
    statsApi
      .getChurnRate(jwt, startDate, endDate)
      .then(res => {
        const chart = generateChart(
          res.data?.data.map(item => [item?.churnRate ?? 0]),
          ["Churn rate"],
          res.data?.data?.map(item => item?.date)
        );
        setChurnRate(chart);
        setIsLoadingChurnRate(false);
      })
      .catch(e => getRequestError(e));
  }, [endDate, jwt, startDate]);

  return (
    <div>
      <div>
        <Chart
          data={churnRate || []}
          type="churn"
          title="Churn rate"
          height={80}
          xLabel="Months"
          yLabel="Rate (%)"
          hasFullReport={false}
          loading={isLoadingChurnRate}
          filterComponent={
            <div className={filterContainer}>
              <CSVLink
                data={
                  churnRate?.labels.map((item, index) => ({
                    date: item,
                    rate: churnRate?.datasets[0].data[index]
                  })) ?? []
                }
                filename={"churn-rate.csv"}
              >
                <button disabled={isLoadingChurnRate} className="export-btn">
                  <DownloadIcon color="#A233E2" />
                  EXPORT REPORT
                </button>
              </CSVLink>
              <div className={filter}>
                <DateSelector
                  value={startDate}
                  onChange={e => setStartDate(moment(e).format("YYYY-MM-DD"))}
                />
              </div>
              <div className={filter}>
                <DateSelector
                  value={endDate}
                  onChange={e => setEndDate(moment(e).format("YYYY-MM-DD"))}
                />
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default ChurnRate;
